import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    html {
        background: #FBFBFB;
        height: 100%;
    }

    body {
        margin: 0;
        height: 100%;
    }

    #root {
        height: 100%;
    }

    html, body, h1, h2, h3, h4, h5, h6, p, labal, a {
        font-family: 'Open sans', Arial, sans-serif;
    }

    a:hover {
        cursor: pointer;
    }

    a:disabled {
        cursor: disabled;
    }

    // MUI Overrides
    .MuiGrid-root.MuiGrid-container.MuiGrid-item button {
        line-height: 40px // 56px total height
    }
`;

export default GlobalStyle;
